<div class="my-container header" style="background-color:#babfc7">
  <div class="my-container" style="background-color:#e7e7e7;">
    <div class="backdrop">
      <div class="cssload-loader">
        <div class="cssload-inner cssload-one"></div>
        <div class="cssload-inner cssload-two"></div>
        <div class="cssload-inner cssload-three"></div>
      </div>
    </div>
    <div class="allSides row"
      style="padding-left: 0%;margin-left:0%;margin-right:0%;background-image: url(../assets/images/CGFHeader_bg.jpg);">
      <div class="col-sm-12 col-md-12 col-xs-12 col-lg-12" style="padding-left:0%;padding-right:0%;width:98%;">
        <img border="0" class="custom-header"  src="../assets/images/CGHeader_Main.png"
          alt="MyJax Community Connect" title="MyJax Community Connect">

      </div>
    </div>

    

    <div class="row" style="margin-left:0%;margin-right:0%;">
      <div class="col-sm-12 col-md-12 col-xs-12 col-lg-12 heightclass" style="padding-left:0%;padding-right:0%;">
        <div>
          <app-adminmenu></app-adminmenu>

          
          <!-- Page Wrapper -->
          <div id="wrapper">
            <!-- Content Wrapper -->
            <div id="content-wrapper" class="d-flex flex-column">

              <!-- Main Content -->
              <!-- <div id="content" > -->
                <!-- Begin Page Content -->
                <router-outlet></router-outlet>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row" style="margin-left:0%;margin-right:0%;">
      <footer class="main-footer">
        <div class="col-sm-12 col-md-12 col-xs-12 col-lg-12">
          <p _ngcontent-c0="" style="font-size:14px;margin-top: 0.3%;">
            <img border="0" src="../assets/images/coj_logo_bot_bar.png" alt="City of Jacksonville"
              title="City of Jacksonville" width="76" style="float: left;margin-right:1%; margin-top:-4px">
            <font color="white"
              title="If you experience difficulty viewing or accessing the documents provided on this site, or navigating this application's table features, using any assistive technology please contact the Disabled Services Division at 904-630-4940 or 904-630-4933(TTY) to request an accommodation. &copy; 2022 - Official City of Jacksonville and Duval County Government Website, All Rights Reserved."
              tabindex="0">If you experience difficulty viewing or accessing the documents
              provided on this site, or navigating this
              application's table features, using any assistive technology please contact the Disabled Services
              Division
              at (904) 255-5466 or (904) 255-5475 to request an accommodation.
              <br /> &copy; 2023 - Official City of Jacksonville and Duval County Government Website, All Rights
              Reserved | Version 1.0
            </font>
          </p>
        </div>
      </footer>

    </div>


  </div>
